function contentpuff() {
    function initContentPuff(el) {
        var $el = $(el);
        var $content = $el.find('.c-product-nav__items');        
        var $prev = $el.find('.mobile-scroll-wrapper-prev');
        var $next = $el.find('.mobile-scroll-wrapper-next');
        var width =  $content.children(':first').width();

        $next.on('click', function() {            
            $content.animate({
                scrollLeft: '+=' + width
            }, 300, 'swing');
            return false;
        });

        $prev.on('click', function() {            
            $content.animate({
                scrollLeft: '-=' + width
            }, 300, 'swing');
            return false;
        });

    }
    return {
        initContentPuff: initContentPuff
      };
}

(function ($, document, window) {
    $(function () {
      $('.mobile-scroll-wrapper').each(function (idx, el) {
        var cp = new contentpuff();
        cp.initContentPuff(el);
      });
    })
  }(jQuery, document, window));